"use strict";
// CIP fork feature (see FORK.md): filling a Studio system prompt's
// `{{variables}}` with what a call renders for them.
//
// Deliberately not `compileChatMessages` (../../llm/compileChatMessages.ts):
// that substitutes one variable at a time with `String.replace` and a string
// replacement, so a participant's statement containing `$&` or `{{other}}`
// would be rewritten by the next substitution. One pass with a function
// replacement treats every value as literal text, and a placeholder no value
// was given for is left as written, so an author who adds `{{something}}` to
// a prompt sees it unchanged rather than a crash.
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDIO_PROMPT_VARIABLE_REGEX = void 0;
exports.compileStudioPromptText = compileStudioPromptText;
exports.compileStudioPromptMessages = compileStudioPromptMessages;
exports.extractStudioPromptVariables = extractStudioPromptVariables;
/** A placeholder: `{{name}}`, a letter first, as Langfuse's own variables. */
exports.STUDIO_PROMPT_VARIABLE_REGEX = /\{\{\s*(\p{L}[\p{L}\p{N}_]*)\s*\}\}/gu;
function compileStudioPromptText(template, variables, options = {}) {
    const filled = template.replace(exports.STUDIO_PROMPT_VARIABLE_REGEX, (match, name) => Object.prototype.hasOwnProperty.call(variables, name)
        ? variables[name]
        : match);
    return options.trim === false ? filled : filled.trim();
}
function compileStudioPromptMessages(messages, variables, options = {}) {
    return messages.map((message) => ({
        role: message.role,
        content: compileStudioPromptText(message.content, variables, options),
    }));
}
/** The placeholder names a template (or a list of them) mentions, in order. */
function extractStudioPromptVariables(templates) {
    const found = new Set();
    for (const template of typeof templates === "string"
        ? [templates]
        : templates) {
        for (const match of template.matchAll(exports.STUDIO_PROMPT_VARIABLE_REGEX)) {
            found.add(match[1]);
        }
    }
    return [...found];
}
